import { CanvasJSChart } from 'app/components/CanvasJs';
import React, { useCallback, useEffect, useState } from 'react';

const CircularProgressBar = ({ progress }) => {
  const [currentProgress, setCurrentProgress] = useState(progress);

  const formatarProgresso = useCallback((progress) => {
    const valorFormatado = Math.min(Math.max(progress, 0), 100);
    return valorFormatado.toFixed(1);
  }, []);

  useEffect(() => {
    if (progress !== currentProgress) {
      const progressoFormatado = formatarProgresso(progress);
      setCurrentProgress(progressoFormatado);
    }
  }, [progress, currentProgress, formatarProgresso]);

  return (
    <CanvasJSChart
      options={{
        culture: 'pt-br',
        animationEnabled: true,
        toolTip: {
          shared: true,
        },
        legend: {
          fontSize: 12,
          cursor: 'pointer',
          verticalAlign: 'bottom',
        },
        width: 500,
        height: 200,
        data: [
          {
            type: 'doughnut',
            startAngle: -90,
            dataPoints: [
              {
                y: parseFloat(currentProgress),
                toolTipContent: '{y}% concluído',
                color: '#483285',
              },
              {
                y: 100 - parseFloat(currentProgress),
                toolTipContent: '{y}% pendente',
                color: 'rgba(156, 39, 176, 0.2)',
              },
            ],
          },
        ],
      }}
    />
  );
};

export default CircularProgressBar;
